module.exports = __webpack_public_path__ + "img/centre_eaton.b893e169.webp";